// extracted by mini-css-extract-plugin
module.exports = {"artistLink":"styles_artistLink__J_sVl","artistName":"styles_artistName__sQuO2"};